<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div slot="header">
            {{ $lang.relation_person_company }}
          </div>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-row>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.company"
                  label-for="company_id"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.company"
                    :rules="$v.company_id.$params"
                  />

                  <selectAsync
                    :options="company_options"
                    v-model="$v.company_id.$model"
                    label="name"
                    :asyncFind="getCompanies"
                    :isValid="
                      $v.company_id.$dirty ? !$v.company_id.$error : null
                    "
                    :loading="companyLoading"
                  />

                  <b-form-invalid-feedback id="company_id-feedback"
                    >{{ $lang.error_required | replace($lang.company) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.post"
                  label-for="post"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.post"
                    :rules="$v.post.$params"
                  />
                  <b-form-input
                    id="post"
                    v-model="post"
                    type="text"
                    :autocomplete="$lang.post"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.personCompany.from_date"
                  label-for="from_date"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.personCompany.from_date"
                    :rules="$v.from_date.$params"
                  />
                  <date-picker
                    v-model="$v.from_date.$model"
                    :state="$v.from_date.$dirty ? !$v.from_date.$error : null"
                    format="YYYY/MM/DD"
                    display-format="jYYYY/jMM/jDD"
                    min="1990/01/01"
                    :max="new Date() | moment('YYYY/MM/DD')"
                    inputReq="true"
                    clearable
                    :class="
                      $v.from_date.$dirty
                        ? $v.from_date.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{ display: $v.from_date.$error ? 'block' : 'none' }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.personCompany.from_date)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.personCompany.to_date"
                  label-for="to_date"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.personCompany.to_date"
                    :rules="$v.to_date.$params"
                  />
                  <date-picker
                    v-model="$v.to_date.$model"
                    :state="$v.to_date.$dirty ? !$v.to_date.$error : null"
                    format="YYYY/MM/DD"
                    display-format="jYYYY/jMM/jDD"
                    :min="from_date"
                    :max="new Date() | moment('YYYY/MM/DD')"
                    inputReq="true"
                    clearable
                    :class="
                      $v.to_date.$dirty
                        ? $v.to_date.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{ display: $v.to_date.$error ? 'block' : 'none' }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.personCompany.to_date)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.description"
                  label-for="description"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.description"
                    :rules="$v.description.$params"
                  />
                  <b-form-textarea
                    id="description"
                    v-model="$v.description.$model"
                    :rows="this.$config.form.textareaRows"
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  name: "add-person-company",
  validations: {
    company_id: {
      required,
    },
    post: {},
    from_date: {},
    to_date: {},

    description: {},
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    entity: {
      type: String,
      default: "person",
    },
    entityId: {
      type: String,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      entityKey: "person_company",
      company_id: null,
      post: "",
      to_date: null,
      from_date: null,
      industry_selected: null,
      description: "",
      companyLoading: false,
      company_options: [],
    };
  },
  methods: {
    spliceNumber(event) {
      let splice = event.target.value
        .replace(/,/gi, "")
        .split(/(?=(?:\d{3})+$)/)
        .join(",");
      event.target.value = splice;
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.company_id = "";
      this.post = "";
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    getCompanies(query) {
      if (!query || query.length < 3) {
        this.company_options = [];
        return;
      }

      this.$httpService
        .get(
          this.$config.api_url +
            this.$config.resources.company +
            "?name=" +
            query
        )
        .then((response) => {
          if (response.status !== 200) {
            this.$notify.error(response.data.message);
            return;
          }

          let company;
          company = response.data.data.result;
          this.company_options = company;
        })
        .catch((err) => {
          this.company_options = [];
        });
    },
    getIndustry() {
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.metaData.entity_enum_builder
              .replace("{entity}", this.entityKey)
              .replace("{enum}", "industry")
        )
        .then((response) => {
          let industry = response.data.data;

          industry = industry.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
              id: x.id,
            };
          });
          this.industry_options = industry;

          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        });
    },
    getSubIndustry(item) {
      this.sub_industry_loading = true;
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.metaData.entity_enum_builder
              .replace("{entity}", this.entityKey)
              .replace("{enum}", "sub_industry") +
            `?parent_id=${item ? item.id : ""}`
        )
        .then((response) => {
          let subIndustry = response.data.data;
          subIndustry = subIndustry.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          this.sub_industry_options = subIndustry;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        })
        .finally(() => (this.sub_industry_loading = false));
    },
    getOrganizationType() {
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.metaData.entity_enum_builder
              .replace("{entity}", this.entityKey)
              .replace("{enum}", "organization_type")
        )
        .then((response) => {
          let organization_type = response.data.data;
          organization_type = organization_type.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          this.organization_type_options = organization_type;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        });
    },
    getPrimaryJobFunction() {
      this.primary_job_function_Loading = true;
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.metaData.entity_enum_builder
              .replace("{entity}", this.entityKey)
              .replace("{enum}", "primary_job_function")
        )
        .then((response) => {
          let primary_job_function = response.data.data;
          primary_job_function = primary_job_function.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
              id: x.id,
            };
          });
          this.primary_job_function_options = primary_job_function;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        });
    },
    getJobSubFunction(item) {
      this.job_sub_function_loading = true;
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.metaData.entity_enum_builder
              .replace("{entity}", this.entityKey)
              .replace("{enum}", "job_sub_function") +
            `?parent_id=${item ? item.id : ""}`
        )
        .then((response) => {
          let job_sub_function = response.data.data;
          job_sub_function = job_sub_function.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          this.job_sub_function_options = job_sub_function;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        })
        .finally(() => (this.job_sub_function_loading = false));
    },
    getTypeOfEmployment() {
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.metaData.entity_enum_builder
              .replace("{entity}", this.entityKey)
              .replace("{enum}", "type_of_employment")
        )
        .then((response) => {
          let type_of_employment = response.data.data;
          type_of_employment = type_of_employment.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          this.type_of_employment_options = type_of_employment;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        });
    },
    getJobLevel() {
      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.metaData.entity_enum_builder
              .replace("{entity}", this.entityKey)
              .replace("{enum}", "job_level")
        )
        .then((response) => {
          let job_level = response.data.data;
          job_level = job_level.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          this.job_level_options = job_level;
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.message);
          throw "error";
        });
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let other_compensation_val =
        this.value_other_compensation &&
        this.value_other_compensation.includes(",")
          ? parseInt(this.value_other_compensation.replace(/,/g, ""))
          : this.value_other_compensation;
      let annual_bonus_val =
        this.annual_bonus && this.annual_bonus.includes(",")
          ? parseInt(this.annual_bonus.replace(/,/g, ""))
          : this.annual_bonus;
      let base_salary_val =
        this.base_salary && this.base_salary.includes(",")
          ? parseInt(this.base_salary.replace(/,/g, ""))
          : this.base_salary;

      this.isLoading = true;
      let payload = {
        person_code: this.$route.params.code,
        position: this.post,
        is_enable: this.is_enable,
        from_date: this.from_date,
        to_date: this.to_date,
        industry_id: this.industry_selected
          ? this.industry_selected.value
          : null,
        sub_industry_id: this.sub_industry_selected
          ? this.sub_industry_selected.value
          : null,
        organization_type_id: this.organization_type_selected
          ? this.organization_type_selected.value
          : null,
        primary_job_function_id: this.primary_job_function_selected
          ? this.primary_job_function_selected.value
          : null,
        job_sub_function_id: this.job_sub_function_selected
          ? this.job_sub_function_selected.value
          : null,
        base_salary: base_salary_val,
        annual_bonus: annual_bonus_val,
        value_other_compensation: other_compensation_val,
        type_of_employment_id: this.type_of_employment_selected
          ? this.type_of_employment_selected.value
          : null,
        job_level_id: this.job_level_selected
          ? this.job_level_selected.value
          : null,
        description: this.description,
      };

      this.$httpService
        .post(
          this.$config.api_url +
            this.$config.resources.person_company.replace(
              "{0}",
              this.company_id.code
            ),
          payload
        )
        .then((response) => {
          this.isLoading = false;
          this.$notify.success(response.data.message);
          this.afterSave();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify.error(err.response.data.message);
        });
    },
  },
  created() {
    this.getIndustry().finally(() => {
      this.industry_Loading = false;
    });

    this.getOrganizationType().finally(() => {
      this.organization_type_Loading = false;
    });
    this.getPrimaryJobFunction().finally(() => {
      this.primary_job_function_Loading = false;
    });

    this.getTypeOfEmployment().finally(() => {
      this.type_of_employment_Loading = false;
    });

    this.getJobLevel().finally(() => {
      this.job_level_Loading = false;
    });
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}
</style>
